
import React, { useEffect, useRef, useState } from 'react'
import Papa, { parse } from 'papaparse';
import { generate } from "random-words";
import emails from '../../arrays/emails.json'
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import Pagination from '../Paginations';
import { createBulkUsers, getAllUsers, updateUser } from '../../api/user';
import { snakeToCamel } from './AdminEditRelease';
import { getPlatforms } from '../../api/platforms';
import { createBulkArtists, getAllArtists } from '../../api/artists';
import { bulkCreateClaims } from '../../api/claims';
import { createBulkLabels } from '../../api/labels';
import { createBulkReleases } from '../../api/releases';
import { useQuery } from '@tanstack/react-query'
import { CircularProgress, Alert } from '@mui/material'

const AdminUsers = () => {

    const [users, setUsers] = useState([])
    const [filteredUsers, setFilteredUsers] = useState([])
    const [uploadMessage, setUploadMessage] = useState('Upload Claims')
    const [uploadReportsMessage, setUploadReportsMessage] = useState('Upload Reports')
    const [uploadReleasesMessage, setUploadReleasesMessage] = useState('Upload Releases')
    const [platforms, setPlatforms] = useState([])
    const [errors, setErrors] = useState([])
    const [artists, setArtists] = useState([])
    const claimsSuccess = useRef()
    const reportsSuccess = useRef()
    const errorBtn = useRef()
    const navigate = useNavigate()

    const { 
        data: usersData, 
        isLoading: isLoadingUsers, 
        error: usersError 
    } = useQuery({
        queryKey: ['users'],
        queryFn: getAllUsers,
        select: (data) => data.map(user => ({
            id: user.user_id, 
            ...snakeToCamel(user), 
            payeeID: user.payee_id, 
            customID: user.custom_id
        }))
    })

    const { 
        data: platformsData,
        isLoading: isLoadingPlatforms 
    } = useQuery({
        queryKey: ['platforms'],
        queryFn: getPlatforms,
        select: (data) => data.platforms
    })

    const { 
        data: artistsData,
        isLoading: isLoadingArtists 
    } = useQuery({
        queryKey: ['artists'],
        queryFn: getAllArtists,
        select: (data) => data.artists
    })

    useEffect(() => {
        if (usersData) {
            setUsers(usersData)
            setFilteredUsers(usersData)
        }
        if (platformsData) {
            setPlatforms(platformsData)
        }
        if (artistsData) {
            setArtists(artistsData)
        }
    }, [usersData, platformsData, artistsData])
    


    const handleSearch = (event) => {
        const term = event.target.value;

        setCurrentPage(1)
    
        const filteredResults = users.filter((user) => {
          const { email, firstName, lastName, customID, payeeID } = user;
          const lowerCaseTerm = term.toLowerCase();
    
          // Check if the item's properties contain the search term
          return (
            email && email.toLowerCase().includes(lowerCaseTerm) ||
            firstName && firstName.toLowerCase().includes(lowerCaseTerm) ||
            lastName && lastName.toLowerCase().includes(lowerCaseTerm) ||
            customID && customID.toLowerCase().includes(lowerCaseTerm) ||
            payeeID && payeeID.toLowerCase().includes(lowerCaseTerm)
          );
        });
    
        setFilteredUsers(filteredResults);
    };


    /////////// PAGINATION ///////////
    const itemsPerPage = 25;
    const [currentPage, setCurrentPage] = useState(1);

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredUsers.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };



    const [csvData, setCsvData] = useState([]);

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        setUploadMessage('Please Wait...')

        if (file) {
        Papa.parse(file, {
            complete: (result) => {
            // Parse CSV data and store it in state
            setCsvData(result.data)
            // console.log(result.data)
            updateUserClaims(result.data)
            },
            header: true, // Set this to true if your CSV file has a header row
        });
        }
    }


    const updateUserClaims = (claims) => {
    //     const usersRef = ref(db, "users");
      
    //     return get(usersRef)
    //       .then((usersSnapshot) => {
    //         if (usersSnapshot.exists()) {
    //           const usersData = usersSnapshot.val();
            
    //           // Iterate through each user synchronously using Object.entries
    //           Object.entries(usersData).forEach(([userId, user]) => {
    //             const { prefix } = user;
    //             const claimsToUpdate = [];
      
    //             // Iterate through your array of objects (videos)
    //             claims.forEach((claim) => {
    //               if (claim.custom_id.startsWith(prefix) 
    //                 && claim.claim_type === 'AUDIO' 
    //                 && claim.claim_status === 'ACTIVE'
    //                 && claim.video_id !== '') {
    //                 claimsToUpdate.push({
    //                     url: claim.video_id,
    //                     views: claim.views,
    //                     track: claim.asset_title,
    //                     artist: claim.artist,
    //                     channel: claim.channel_display_name
    //                 });
    //               }
    //             });
      
    //             // Update the user's claims property in Firebase
    //             const userClaimsRef = ref(db, `users/${userId}`);
    //             return update(userClaimsRef, {claims: claimsToUpdate});
    //           });
      
    //           console.log("Claims updated successfully!");
    //           claimsSuccess.current.click()
    //           setUploadMessage('Upload Claims')
    //         } else {
    //           console.log("No users found in the database.");
    //         }
    //       })
    //       .catch((error) => {
    //         console.error("Error updating claims:", error);
    //       });
    }



    const reportsInput = useRef()
    const reportSuccess = useRef()
    

    const sortChannels = (data) => {
        const channelRevenueMap = data.reduce((acc, report) => {
            const { channel, taxesnet_total_client_currency } = report;
            acc[channel] = (acc[channel] || 0) + taxesnet_total_client_currency * 1;
            return acc;
        }, {});
        const sortedChannels = Object.keys(channelRevenueMap).sort((a, b) => {
            return channelRevenueMap[b] - channelRevenueMap[a];
        });
        const topChannels = sortedChannels.slice(0, 4);
        const resultObjects = topChannels.map(channel => {
            return {
              channel: channel,
              totalRevenue: channelRevenueMap[channel],
              // ... other properties you want to include in the result object
            };
        });
        return resultObjects
    }

    

    // const groupSplits = (tracks, splits) => {
    //     const groupedTracks = [];

    //     // Iterate over each track
    //     tracks.forEach((track) => {
    //         const { isrc, taxesnet_total_client_currency } = track;

    //         // Check if the isrc already exists in groupedTracks
    //         const existingTrack = groupedTracks.find((groupedTrack) => groupedTrack.isrc === isrc);

    //         // If the isrc doesn't exist, create a new entry
    //         if (!existingTrack) {
    //             groupedTracks.push({ isrc, total_price: taxesnet_total_client_currency * 1 });
    //         } else {
    //             // If the isrc exists, update the total price
    //             existingTrack.total_price += taxesnet_total_client_currency * 1;
    //         }
    //     });

    //     groupedTracks.forEach((track) => {

    //     })
    // }


    let collabReports = []
    
    const checkTotalRecoup = (user, isrc) => {
        const entries = collabReports.filter(entry => entry.user === user && entry.isrc === isrc);
      
        // Calculate the total amount for the found entries
        const totalAmount = entries.reduce((sum, entry) => sum + entry.addedPrice * 1, 0);
      
        return totalAmount;
    };

    const remainingPrice = (splits, price, isrc) => {
        let totalPercentage = 0;
        let sharePrice = 0

        const recoupExist = splits.find(item => item.recoupment * 1 > 0 && item.track === isrc)

        // Calculate prices for each share
        // if (recoupExist && recoupExist.recoupment * 1 > checkTotalRecoup(recoupExist.user, recoupExist.track)) {
        //     const recoupPrice = Math.min(recoupExist.recoupment * 1, price)
        //     collabReports = [...collabReports, {user: recoupExist.user, addedPrice: recoupPrice, isrc, recoupPrice: recoupExist.recoupment * 1}]
        //     sharePrice = price
        // } else {
            splits.forEach(({ share, user, track }) => {
                if (track === isrc) {
                    const userShare = (share / 100) * price;
                    collabReports = [...collabReports, {user, addedPrice: userShare, recoupPrice: 0, isrc}]
                    sharePrice += userShare
                    // console.log(`${userShare} for ${user} from ${price}`);
                } else {}
            });
        // }
        
        // Calculate and log the price for the remaining percentage
        const remainingPrice = price - sharePrice;
        // console.log(`${price - sharePrice} instead of ${price}`);
        return remainingPrice
    }


    const groupCollabs = (collabArray) => {
      
        const groupedCollabs = [];
        const existingCollabs = []
        
        // Iterate over each track
        collabArray.forEach((collabUser) => {
            const { user, addedPrice, recoupPrice, isrc } = collabUser;

            // Check if the isrc already exists in groupedCollabs
            const existingUser = groupedCollabs.find((groupedUser) => groupedUser.user === user);
            
            // If the isrc doesn't exist, create a new entry
            if (!existingUser) {
                groupedCollabs.push({ user, price: addedPrice * 1, recoupPrice, isrc });
            } else {
                existingUser.price += addedPrice * 1;
            }
        });

        groupedCollabs.forEach(item => {
            users.forEach(dbuser => {
                if (dbuser.email === item.user) {
                    existingCollabs.push({user: item.user, price: ((dbuser.balance * 1) || 0) + item.price, key: dbuser.id, recoupPrice: item.recoupPrice, isrc: item.isrc})
                }
            })
        })

        return existingCollabs
    }


    const clearRecoupment = (splits, user, isrc, newRecoup) => {
        let newSplits = [...splits]
        const index = splits.findIndex(entry => entry.user === user && entry.track === isrc);
        if (index !== -1) {
          // Update the amount for the found entry
          newSplits[index].recoupment = newRecoup;
        } else {
        }

        return newSplits
    };







    const groupUsersTracks = (users) => {
        const groupedUsers = users.map((user) => {
            const tracksByISRC = user.tracks.reduce((accumulator, track) => {
            const existingTrack = accumulator.find((t) => t.isrc === track.isrc);

            if (existingTrack) {
                // If track with the same ISRC already exists, update the revenue
                existingTrack.revenueShare += track.revenueShare * 1;
            } else {
                // If track with the same ISRC does not exist, create a new track
                const newTrack = { 
                    isrc: track.isrc, 
                    revenueShare: track.revenueShare, 
                    title: track.title,
                    percentage: track.percentage
                };
                accumulator.push(newTrack);
            }

            return accumulator;
            }, []);

            return {
                user: user.user,
                key: user.key,
                balance: user.balance,
                tracks: tracksByISRC,
            };
        });

        return groupedUsers;
    };

    const groupUsersByEmail = (users) => {
        const groupedUsers = users.reduce((accumulator, user) => {
          const existingUser = accumulator.find((groupedUser) => groupedUser.email === user.user);
      
          if (existingUser) {
            // If user with the same email already exists in the accumulator, update the balance
            existingUser.balance += user.revenueShare * 1;
            existingUser.key = user.key
            existingUser.tracks.push({ 
                revenueShare: user.revenueShare, 
                isrc: user.isrc,
                isRecoupment: user.isRecoupment,
                percentage: user.percentage,
                title: user.title,
                user: user.user
            });
          } else {
            // If user with the same email does not exist, create a new grouped user
            const newUser = {
              key: user.key,
              email: user.user,
              balance: user.revenueShare * 1,
              tracks: [...user.inviteSplits, { 
                revenueShare: user.revenueShare, 
                isrc: user.isrc,
                title: user.title,
                isRecoupment: user.isRecoupment,
                percentage: user.percentage,
                user: user.user
            }],
            };
            accumulator.push(newUser);
          }
      
          return accumulator;
        }, []);
      
        return groupedUsers;
      };

    const groupCollaborators = (array) => {
        const newCollabs = []
        let count = 0
        users.forEach(user => {
            array.forEach(collab => {
                if (collab.user === user.email) {
                    newCollabs.push({
                        key: user.id,
                        // balance: user.balance * 1 || 0,
                        // inviteSplits: user.inviteSplits || [],
                        balance: 0,
                        inviteSplits: [],
                        ...collab
                    })
                }
            })
            count++
        })

        if (count === users.length) {
            return groupUsersByEmail(newCollabs)
        }
    }



    const updateReports = (reports) => {
        
    }




    const handleReportsUpload = (event) => {
        const file = event.target.files[0];
        setUploadReportsMessage('Please Wait...')
        if (file) {
        Papa.parse(file, {
            complete: (result) => {
            // Parse CSV data and store it in state
            // console.log(result.data)
            // calculateMonthlyTotals(result.data)
            updateReports(result.data)
            },
            header: true, // Set this to true if your CSV file has a header row
        });
        }
    }


    ///////////////////////////////////////////////////
    /////////////// RELEASES UPLOADER /////////////////
    ///////////////////////////////////////////////////
    const releasesSuccess = useRef()

    const handleArtists = (artistsString) => {
        if (artistsString) {
            const arrayObjects = artistsString.split('|').map(entry => {
                const [role, name] = entry.split(':');
                const artist = artists.find(item => item.name === name)
                console.log(artist,"artist", artists)
                if (artist) {
                    return { role, name, artistId: artist.id };
                }
            }).filter(el => el);
            return arrayObjects || []
        } else {
            return []
        }
    }

    const handlePlatforms = (platformsString) => {
        if (platformsString) {
            const arrayObjects = platformsString.split('|').map(entry => {
                const platformExist = platforms.find(item => item.title === entry)
                if (platformExist) {
                    return {
                        id: platformExist.id,
                        link: '',
                        checked: true,
                        status: 'Distributed'
                    }
                } else {
                    return null
                }
            });
            return arrayObjects.filter(item => item !== null)
        } else {
            return []
        }
    }

    const getNextNumber = (index) => {
        const nextNumber = String(index).padStart(5, '0');
        return nextNumber;
    }

    const groupReleasesByUser = async (objects) => {
        const releasesToInsert = [];
        for(const obj of objects){
            const userWithEmail = users.find((user) => user.email === obj.user);
            const newRelease = {
                userProfileId: userWithEmail.id,
                ...obj,
                upc: toString(obj.upc),
                copyrightYear: parseInt(obj.copyRightYear) || 2025,
                publishingYear: parseInt(obj.publishingYear) || 2025,
                autoUPC: obj.upc ? true : false,
            }
            releasesToInsert.push(newRelease)
        }
        await createBulkReleases(releasesToInsert);
        
        releasesSuccess.current.click()

    }

    const handleGroupReleases = (releasesArray) => {
        const groupedReleases = releasesArray.reduce((acc, release) => {
          
            // Check if UPC exists in the accumulator
            if (!acc[release['UPC']]) {

                acc[release['UPC']] = {
                    user: release['User email'] || '',
                    title: release['Release title'] || '',
                    tracks: [],
                    upc: release['UPC'].replace(/'/g, '') * 1 || '',
                    artwork: release['Release cover'] || '',
                    status: 'Distributed',
                    wasLive: true,
                    language: release['Language'] || '',
                    primaryGenre: release['Primary genre'] || '',
                    secondaryGenre: release['Secondary genre'] || '',
                    artists: handleArtists(release['Release artists']) || [],
                    countries: ['Worldwide'],
                    digitalDate: release['Digital Release Date'] || '',
                    originalDate: release['Original Release Date'] || '',
                    copyrightYear: release['Copyright Year'] || '',
                    copyrightLine: release['Copyright Line'] || '',
                    publishingYear: release['Publishing Year'] || '',
                    publishingLine: release['Publishing Line'] || '',
                    label: release['Label'] || '',
                    distribution: 'All',
                    platforms: handlePlatforms(release['Channels'])
                };

            }

            var uniqueId = Math.random().toString(36).substr(2, 9);
          
            // Add track and artist to the respective arrays
            const pushedTrack = {
                title: release['Track title'],
                id: uniqueId,
                trackLanguage: release['Track language'],
                isrc: release['ISRC code'],
                clipStart: release['Start point time'],
                genre: release['Track primary genre'],
                explicit: release['Explicit lyrics'] === 'Explicit' ? 'Yes' : 'No',
                artists: handleArtists(release['Track artists']),
                copyright: '',
                autoISRC: false,
                duration: release['Track duration'] || '',
            }
            acc[release['UPC']].tracks.push(pushedTrack);
            // acc[upc].artists.push(artists);
          
            return acc;
          }, {});
          
          // Convert the grouped releases object to an array
          const groupedReleasesArray = Object.values(groupedReleases);
          groupReleasesByUser(groupedReleasesArray);
    }

    const hasCorrectFormat = (items) => {
        let rows = []
        for (let i = 0; i < items.length; i++) {
            const releaseArtists = items[i]['Release artists'];
            const trackArtists = items[i]['Track artists'];
            const channels = items[i]['Channels'];
    
            if (!releaseArtists || !trackArtists) {
                rows.push(`Missing Artists in Row ${i+2}`)
            } else if (!isValidFormat(releaseArtists) || !isValidFormat(trackArtists)) {
                rows.push(`Invalid Artists Format in Row ${i+2}`) // Return the index of the item with incorrect format
            }

            if (!channels) {
                rows.push(`Missing Platforms in Row ${i+2}`)
            } else if (!isValidPlatformFormat(channels)) {
                rows.push(`Invalid Platforms Format in Row ${i+2}`)
            }
        }
        return rows; // If all items have correct format, return -1
    }
    
    function isValidFormat(artists) {
        const pairs = artists.split('|'); // Split the string by '|'
    
        for (const pair of pairs) {
            const [role, name] = pair.split(':'); // Split each pair by ':'
            // Check if both role and name exist
            if (role === undefined || name === undefined) {
                return false; // Return false if any pair is missing role or name
            }
        }
    
        return true; // If all pairs have correct format, return true
    }

    const isValidPlatformFormat = (platforms) => {
        const platformList = platforms.split('|'); // Split the string by '|'
    
        for (const platform of platformList) {
            // Check if the platform is a valid non-empty string
            if (!platform.trim()) {
                return false; // Return false if any platform is empty or contains only whitespace
            }
        }
    
        return true; // If all platforms are non-empty, return true
    }

    const handleReleasesUpload = (event) => {
        const file = event.target.files[0];
        setUploadReleasesMessage('Please Wait...')
        if (file) {
        Papa.parse(file, {
            complete: (result) => {
                const checkErrors = hasCorrectFormat(result.data)
                if (checkErrors.length > 0) {
                    setErrors(checkErrors)
                    errorBtn.current.click()
                } else {
                    handleGroupReleases(result.data)
                }
            },
            header: true, // Set this to true if your CSV file has a header row
        });
        }
    }


    /////////////////////////////////////////////
    ////////////// UPLOAD ARTISTS ///////////////
    /////////////////////////////////////////////
    const [uploadArtistsMessage, setUploadArtistsMessage] = useState('Upload Artists')
    const artistsSuccess = useRef()

    const updateUserArtists = async (objects) => {
        try {
            const artistsToCreate = []
            objects.forEach((item) => {
                const userWithEmail = users.find((user) => user.email === item['User_Email']);
            
                if (userWithEmail) {
                    const newArtist = {
                        user_profile_id: userWithEmail.id,
                        name: item['Name'],
                        website: item['Website'],
                        facebook: item['Facebook'],
                        instagram: item['Instagram'],
                        youtube: item['Youtube'],
                        twitter: item['Twitter'],
                        apple: item['Apple'],
                        spotify: item['Spotify'],
                        deezer: item['Deezer'],
                    }
                    artistsToCreate.push(newArtist);
                }
            });
            await createBulkArtists(artistsToCreate);
            artistsSuccess.current.click();
        } catch (error) {
            setErrors([error.message]);
            errorBtn.current.click();
        }
    }
    
    const handleArtistsUpload = (event) => {
        const file = event.target.files[0];
        setUploadArtistsMessage('Please Wait...')
        if (file) {
        Papa.parse(file, {
            complete: (result) => {
                updateUserArtists(result.data)
            },
            header: true, 
        });
        }
    }


    /////////////////////////////////////////////
    ////////////// UPLOAD LABELS ///////////////
    /////////////////////////////////////////////
    const [uploadLabelsMessage, setUploadLabelsMessage] = useState('Upload Labels')
    const labelsSuccess = useRef()

    const updateUserLabels = async (objects) => {
        try {
            const labelsToCreate = [];
            objects.forEach((item) => {
                const userWithEmail = users.find((user) => user.email === item['User_Email']);
            
                if (userWithEmail) {
                    const newLabel = {
                        user_profile_id: userWithEmail.id,
                        name: item['Name'],
                        logo: item['Logo'],
                    }
                    labelsToCreate.push(newLabel);
                }
            });
            await createBulkLabels(labelsToCreate);
            labelsSuccess.current.click();
        } catch (error) {
            setErrors([error.message]);
            errorBtn.current.click();
        }
    }
    
    const handleLabelsUpload = (event) => {
        const file = event.target.files[0];
        setUploadLabelsMessage('Please Wait...')
        if (file) {
        Papa.parse(file, {
            complete: (result) => {
                updateUserLabels(result.data)
            },
            header: true, 
        });
        }
    }



    /////////////////////////////////////////////
    ////////////// UPLOAD USERS ///////////////
    /////////////////////////////////////////////
    const [uploadUsersMessage, setUploadUsersMessage] = useState('Upload Users')
    const [existingUser, setExistingUser] = useState('')
    const usersSuccess = useRef()
 
    

    const isEmailInArray = (email) => {
        return users.some(obj => obj.email === email);
    }

    const generateRandomId = () => {
        const charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        let result = "";

        for (let i = 0; i < 20; i++) {
            const randomIndex = Math.floor(Math.random() * charset.length);
            result += charset.charAt(randomIndex);
        }

        return result;
    }

    const passwordGenerator = () => {
        const randomNumber = Math.floor(Math.random() * 9000) + 1000;
        const word = `${generate()}-${generate()}-${randomNumber}`
        const randomPassword = word.slice(0, 1).toUpperCase().concat(word.slice(1))
        return randomPassword
    }

    const handleUsers = async (objects) => {
        try {
            const emailUsers = [];
            const new_users = [];
            let duplicateFound = false;
            
            objects.forEach(user => {
                const userExist = isEmailInArray(user['Email']);
                if (userExist) {
                    setExistingUser(user['Email']);
                    duplicateFound = true;
                } else {
                    const generatedPassword = passwordGenerator();
                    const randomID = generateRandomId();
                    const newUser = {
                        userID: randomID,
                        firstName: user['First_name'] || '',
                        lastName: user['Last_name'] || '',
                        email: user['Email'],
                        customID: user['CustomID'],
                        labelsElligible: user['Can_add_labels'] === 'Yes',
                        paymentSetup: user['Payable'] === 'Yes',
                        accountType: 'Artist',
                        country: user['Country'] || '',
                        state: user['State'] || '',
                        city: user['City'] || '',
                        street1: user['Street_1'] || '',
                        street2: user['Street_2'] || '',
                        zip: user['Zip'] || '',
                        phone: user['Contact_phone'] || '',
                        company: user['Company_name'] || '',
                        payoutPercentage: user["Payout_percentage"] != null ? parseFloat(user['Payout_percentage']) : 80,
                        password: generatedPassword
                    };
                    emailUsers.push({
                        email: newUser.email, 
                        firstName: newUser.firstName, 
                        password: newUser.password, 
                        id: randomID
                    });
                    new_users.push(newUser);
                }
            });
            
            if (duplicateFound) {
                // Trigger error modal if any duplicate user was found
                usersError.current.click();
                return;
            }
            
            await createBulkUsers(new_users);
            // Trigger success modal when users are created successfully
            usersSuccess.current.click();
            // Optionally, send emails after a successful upload:
            // sendEmails(emailUsers);
            
        } catch (error) {
            setExistingUser("An error occurred while creating users");
            usersError.current.click();
        }
    }

    useEffect(() => {
        // get(ref(db, 'users'))
        // .then(snapshot => {
        //     const usersData = snapshot.val() || {}; // Get the data from the snapshot
        //     const usersArray = Object.entries(usersData).map(([key, value]) => ({
        //         id: key, // Include the key as "id" property
        //         ...value // Spread the rest of the properties
        //     }));
        //     const bneUsers = usersArray.filter(item => item.email?.includes('@bne.studio') && item.id.length < 27)
        //     // console.log(bneUsers)
        //     const mappedUsers = bneUsers.map(user => ({
        //         email: user.email,
        //         password: user.password,
        //         firstName: user.firstName,
        //         id: user.id
        //     }))
        // })
    }, [])

    const sendEmails = async (users) => {
        
        axios.post('https://bne-backend.vercel.app/emailList', {
            subject: emails[3].subject,
            users: users,
            content: emails[3].content
        })
    
    };
    

    const emailModalBtn = useRef()

    const sendMail = (userObject) => {
        axios.post('https://bne-backend.vercel.app/email', {
            subject: emails[3].subject,
            email: userObject.email,
            content: emails[3].content
                .replace(/\*\|Name\|\*/g, userObject.firstName || 'there')
                .replace(/\*\|Email\|\*/g, userObject.email)
                .replace(/\*\|Password\|\*/g, userObject.password)
                .replace(/\*\|LoginID\|\*/g, userObject.id)
        })
        .then(emailModalBtn.current.click())
    }
    
    
    const handleUsersUpload = (event) => {
        const file = event.target.files[0];
        setUploadUsersMessage('Please Wait...')
        if (file) {
        Papa.parse(file, {
            complete: (result) => {
                handleUsers(result.data)
            },
            header: true, 
        });
        }
    }


    /////////////////////////////////////////////
    ////////////// PAYABLE TOGGLE ///////////////
    /////////////////////////////////////////////
    const handlePayable = async (id, value) => {
        setFilteredUsers(prevUsers => (
            prevUsers.map(user => (
              user.id === id ? { ...user, paymentSetup: value } : user
            ))
        ));
        await updateUser(id,  {
            payment_setup: value,
            setup_request: false
        })
    }
    
    const handleLabels = async (id, value) => {
        setFilteredUsers(prevUsers => (
            prevUsers.map(user => (
              user.id === id ? { ...user, labelsElligible: value } : user
            ))
        ));
        await updateUser(id,  {
            labels_elligible: value
        })
        
    }
    
    const handleTrends = async (id, value) => {
        setFilteredUsers(prevUsers => (
            prevUsers.map(user => (
              user.id === id ? { ...user, trendsAllowed: value } : user
            ))
        ));
        await updateUser(id,  {
            trends_allowed: value,
        })
    }

    const handleAccess = async (id, value) => {
        setFilteredUsers(prevUsers => (
            prevUsers.map(user => (
              user.id === id ? { ...user, accessAllowed: value } : user
            ))
        ));
        await updateUser(id, {
            access_allowed: true,
        })
    }


    /////////////////////////////////////////////
    //////////////// IMPERSONATE ////////////////
    /////////////////////////////////////////////
    const impersonate = (id) => {
        localStorage.setItem('uid', id)
        localStorage.setItem('mid', id)
        navigate('/dashboard/panel')
    }



  return (
    <div className="admin-page py-5">
        <div className='container'>
            <div className="row">
                <div className="col-lg-4 mt-4">
                    <div className="dash-form-file py-4">
                        <i className="fi fi-rr-cloud-upload"></i>
                        {uploadMessage}
                        <input type="file" onChange={handleFileUpload} />
                        <button data-bs-toggle="modal" data-bs-target="#claimsModal" ref={claimsSuccess} hidden></button>
                    </div>
                </div>
                <div className="col-lg-4 mt-4">
                    <Link to="/admin/reports" className="dash-form-file py-4">
                        <i className="fi fi-rr-cloud-upload"></i>
                        {uploadReportsMessage}
                    </Link>
                </div>
                <div className="col-lg-4 mt-4">
                    <div className="dash-form-file py-4">
                        <i className="fi fi-rr-cloud-upload"></i>
                        {uploadReleasesMessage}
                        <input type="file" onChange={handleReleasesUpload} />
                        <button data-bs-toggle="modal" data-bs-target="#releasesModal" ref={releasesSuccess} hidden></button>
                    </div>
                </div>
                <div className="col-lg-4 mt-4">
                    <div className="dash-form-file py-4">
                        <i className="fi fi-rr-cloud-upload"></i>
                        {uploadArtistsMessage}
                        <input type="file" onChange={handleArtistsUpload} />
                        <button data-bs-toggle="modal" data-bs-target="#artistsModal" ref={artistsSuccess} hidden></button>
                    </div>
                </div>
                <div className="col-lg-4 mt-4">
                    <div className="dash-form-file py-4">
                        <i className="fi fi-rr-cloud-upload"></i>
                        {uploadLabelsMessage}
                        <input type="file" onChange={handleLabelsUpload} />
                        <button data-bs-toggle="modal" data-bs-target="#labelsModal" ref={labelsSuccess} hidden></button>
                    </div>
                </div>
                <div className="col-lg-4 mt-4">
                    <div className="dash-form-file py-4">
                        <i className="fi fi-rr-cloud-upload"></i>
                        {uploadUsersMessage}
                        <input type="file" onChange={handleUsersUpload} />
                        <button data-bs-toggle="modal" data-bs-target="#usersModal" ref={usersSuccess} hidden></button>
                        <button data-bs-toggle="modal" data-bs-target="#usersErrorModal" ref={usersError} hidden></button>
                    </div>
                </div>
                <div className="col-12 mt-4">
                    <div className="dash-card">
                        <div className="dash-card-heading">
                            <h2 className="dash-card-title">Users</h2>
                        </div>
                        <input type="text" className='dash-input' onChange={handleSearch} placeholder='Filter by Title, UPC...' />
                        
                        {(isLoadingUsers || isLoadingPlatforms || isLoadingArtists) && (
                            <div style={{ display: 'flex', justifyContent: 'center', padding: '50px 0' }}>
                                <CircularProgress />
                            </div>
                        )}

                        {usersError && (
                            <Alert severity="error" sx={{ margin: '20px 0' }}>
                                Error loading users: {usersError.message}
                            </Alert>
                        )}

                        {!isLoadingUsers && !usersError && (
                            <div className="table-responsive mt-3">
                                <table className="table dash-table wide-table">
                                    <thead>
                                        <tr>
                                            <td>Name</td>
                                            <td>Email</td>
                                            <td>Type</td>
                                            <td>Payee ID</td>
                                            <td>Custom ID</td>
                                            <td>Payout Percentage</td>
                                            <td>Payable</td>
                                            <td>Labels</td>
                                            <td>Daily Trends</td>
                                            <td>Access</td>
                                            <td>Action</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            currentItems.map((user, i) => (
                                                <tr key={i}>
                                                    <td>
                                                        <div className="table-item">
                                                            {user.firstName} {user.lastName}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="table-item">
                                                            {user.email}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="table-item">
                                                            {user.accountType}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="table-item">
                                                            {user.payeeID}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="table-item">
                                                            {user.customID}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="table-item">
                                                            {user.payoutPercentage}%
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="table-item">
                                                            <div 
                                                                className={`toggle ${user.paymentSetup === true && 'active'}`}
                                                                onClick={() => handlePayable(user.id, user.paymentSetup === true ? false : true)}
                                                            >
                                                                <div></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="table-item">
                                                            <div 
                                                                className={`toggle ${user.labelsElligible === true && 'active'}`}
                                                                onClick={() => handleLabels(user.id, user.labelsElligible === true ? false : true)}
                                                            >
                                                                <div></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="table-item">
                                                            <div 
                                                                className={`toggle ${user.trendsAllowed === true && 'active'}`}
                                                                onClick={() => handleTrends(user.id, user.trendsAllowed === true ? false : true)}
                                                            >
                                                                <div></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="table-item">
                                                            <div 
                                                                className={`toggle ${user.accessAllowed === true && 'active'}`}
                                                                onClick={() => handleAccess(user.id, user.accessAllowed === true ? false : true)}
                                                            >
                                                                <div></div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="table-item d-flex">
                                                            <Link 
                                                                className="table-action-btn a-blue me-1"
                                                                to={`/admin/users/${user.id}`}
                                                            >
                                                                <i className="fi fi-rr-pencil"></i>
                                                            </Link>
                                                            <button 
                                                                className="table-action-btn a-green me-1"
                                                                onClick={() => impersonate(user.id)}
                                                            >
                                                                <i className="fi fi-rr-eye"></i>
                                                            </button>
                                                            <button 
                                                                className={`table-action-btn me-1 ${user.password === undefined && 'disabled'}`}
                                                                disabled={user.password !== undefined ? false : true}
                                                                onClick={() => sendMail(user)}
                                                            >
                                                                <i className="fi fi-rr-envelope"></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                        )}
                        
                        {!isLoadingUsers && !usersError && (
                            <Pagination 
                                currentPage={currentPage} 
                                totalPages={totalPages} 
                                handlePageChange={handlePageChange} 
                            />
                        )}
                    </div>
                </div>
            </div>


        </div>

        <input type="file" onChange={handleReportsUpload} ref={reportsInput} hidden/>
        <button data-bs-toggle="modal" data-bs-target="#reportsModal" ref={reportSuccess} hidden></button>


        <div className="modal fade" id="claimsModal" tabindex="-1" data-bs-backdrop="static" aria-labelledby="claimsModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-body success-modal">
                        <a className='success-close-btn' href="/admin/users">
                            <i className="fi fi-rr-cross"></i>
                        </a>
                        <i className="fi fi-rr-check-circle text-success success-icon"></i>
                        <h5>Claims Updated Successfully!</h5>
                    </div>
                </div>
            </div>
        </div>
        
        <div className="modal fade" id="reportsModal" tabindex="-1" data-bs-backdrop="static" aria-labelledby="reportsModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-body success-modal">
                        <a className='success-close-btn' href="/admin/users">
                            <i className="fi fi-rr-cross"></i>
                        </a>
                        <i className="fi fi-rr-check-circle text-success success-icon"></i>
                        <h5>Reports Updated Successfully!</h5>
                    </div>
                </div>
            </div>
        </div>
        
        <button data-bs-toggle="modal" data-bs-target="#releasesModal" ref={releasesSuccess} hidden></button>
        <div className="modal fade" id="releasesModal" tabindex="-1" data-bs-backdrop="static" aria-labelledby="releasesModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-body success-modal">
                        <a className='success-close-btn' href="/admin/users">
                            <i className="fi fi-rr-cross"></i>
                        </a>
                        <i className="fi fi-rr-check-circle text-success success-icon"></i>
                        <h5>Releases Updated Successfully!</h5>
                    </div>
                </div>
            </div>
        </div>

        <div className="modal fade" id="artistsModal" tabindex="-1" data-bs-backdrop="static" aria-labelledby="artistsModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-body success-modal">
                        <a className='success-close-btn' href="/admin/users">
                            <i className="fi fi-rr-cross"></i>
                        </a>
                        <i className="fi fi-rr-check-circle text-success success-icon"></i>
                        <h5>Artists Updated Successfully!</h5>
                    </div>
                </div>
            </div>
        </div>
        
        <div className="modal fade" id="labelsModal" tabindex="-1" data-bs-backdrop="static" aria-labelledby="labelsModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-body success-modal">
                        <a className='success-close-btn' href="/admin/users">
                            <i className="fi fi-rr-cross"></i>
                        </a>
                        <i className="fi fi-rr-check-circle text-success success-icon"></i>
                        <h5>Labels Updated Successfully!</h5>
                    </div>
                </div>
            </div>
        </div>
        
        <div className="modal fade" id="usersErrorModal" tabindex="-1" aria-labelledby="usersErrorModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-body success-modal">
                        <a className='success-close-btn' href="/admin/users">
                            <i className="fi fi-rr-cross"></i>
                        </a>
                        <i className="fi fi-rr-cross-circle text-danger success-icon"></i>
                        <h5>User {existingUser} already exists</h5>
                    </div>
                </div>
            </div>
        </div>

        <div className="modal fade" id="usersModal" tabindex="-1" data-bs-backdrop="static" aria-labelledby="usersModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-body success-modal">
                        <a className='success-close-btn' href="/admin/users">
                            <i className="fi fi-rr-cross"></i>
                        </a>
                        <i className="fi fi-rr-check-circle text-success success-icon"></i>
                        <h5>Users Uploaded Successfully!</h5>
                    </div>
                </div>
            </div>
        </div>

        <button data-bs-toggle="modal" data-bs-target="#errorModal" ref={errorBtn} hidden></button>
        <div className="modal fade" id="errorModal" tabindex="-1" data-bs-backdrop="static" aria-labelledby="errorModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-body success-modal pb-3">
                        <a 
                            href={'/admin/users'} 
                            className='success-close-btn' 
                            // data-bs-dismiss="modal"
                        >
                            <i className="fi fi-rr-cross"></i>
                        </a>
                        {
                            errors.map((item, i) => (
                                <h6 className='error-item' key={i}>{item}</h6>
                            )) 
                        }
                    </div>
                </div>
            </div>
        </div>

        <button ref={emailModalBtn} data-bs-toggle="modal" data-bs-target="#emailModal" hidden></button>
        <div className="modal fade" id="emailModal" tabindex="-1" data-bs-backdrop="static" aria-labelledby="emailModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-body success-modal">
                        <a className='success-close-btn' href="/admin/users">
                            <i className="fi fi-rr-cross"></i>
                        </a>
                        <i className="fi fi-rr-check-circle text-success success-icon"></i>
                        <h5>Email Sent!</h5>
                    </div>
                </div>
            </div>
        </div>

    </div>
  )
}

export default AdminUsers